import React from 'react';
import {Route, Switch} from 'react-router-dom';

import {Place} from '../screens/Admin/Place';
import {People} from '../screens/Admin/People';

import Home from '../screens/Home';
import About from '../screens/About';

import {Categories} from '../screens/Categories';

import Details from '../screens/Details';
import {City} from '../screens/City';
import {Columnists} from '../screens/Columnists';
import Help from '../screens/Help';
import Contact from '../screens/Contact';
import {Users} from '../screens/Users';

import NoMatch from '../screens/Errors/404';
import {Footer} from "../components/Footer";

import PrivateRoute from './PrivateRoute'

export default () => {

    return (
        <React.Fragment>
            <Switch>
                <Route exact path='/' component={Home}/>
                <Route exact path='/home/:id/:slug' component={Home}/>
                <Route exact path='/about' component={About}/>

                <PrivateRoute path='/place' component={Place}/>
                <PrivateRoute path='/people' component={People}/>
                {/*<Route path='/place' component={Place}/>*/}
                {/*<Route path='/people' component={People}/>*/}

                <Route path='/users' component={Users}/>

                /* route ok */
                <Route
                    exact
                    path='/categories/:id/:slug'
                    component={
                        (props) => <Categories from={'places'} {...props} />
                    }
                />

                /* route ok */
                <Route
                    exact
                    path='/events'
                    component={
                        (props) => <Categories from={'events'} {...props} />
                    }
                />

                /* route ok */
                <Route
                    exact
                    path='/search'
                    component={
                        (props) => <Categories from={'search'} {...props} />
                    }
                />

                <Route
                    exact
                    path='/:from/details/:id/:title'
                    component={(props) => <Details {...props} />}
                />

                <Route
                    exact
                    path='/city/:id/:title/:action/:get_id/:get_slug'
                    component={
                        (props) => <City {...props} from={'city'}/>
                    }
                />

                <Route
                    exact
                    path='/columnists/:id/:title/:action/:get_id/:get_slug'
                    component={
                        (props) => <City {...props} from={'columnists'}/>
                    }
                />

                <Route
                    exact
                    path='/columnists/:id/:title'
                    component={
                        (props) => <Columnists {...props}/>
                    }
                />

                <Route
                    exact
                    path='/espaco-horizonte/:action/:get_id/:get_slug'
                    component={Home}
                    // component={
                    //     (props) => <City
                    //         {...props}
                    //         blog={{
                    //             id: 4,
                    //             title: 'espaco-horizonte',
                    //             path: '/espaco-horizonte'
                    //         }}
                    //     />
                    // }
                />

                <Route
                    exact
                    path='/:action/:get_id/:get_slug'
                    component={
                        (props) => <City
                            {...props}
                            pages
                        />
                    }
                />

                <Route exact path='/help' component={Help}/>

                <Route exact path='/contact' component={Contact}/>

                <Route component={NoMatch}/>
            </Switch>
            <Footer/>
        </React.Fragment>
    );
}